import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import {
  appDynamicsContent,
  APP_DYNAMICS_CDN,
  pendoContent,
  getLogRocketConfig,
  LogRocketConfig
} from 'AppSettings'
import store from './app/store'
import { getOrCreateUnauthenticatedSessionId } from 'utils/unauthenticatedSession'
import 'jquery'
import 'popper.js'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import 'react-datepicker/dist/react-datepicker.css'
import '@mdi/font/scss/materialdesignicons.scss'
import '@stretto/cds-tokens/lib/css/base.css'
import './style/main.scss'
import './style/main.css'

const vh = window.innerHeight * 0.01

const injectHead = (content: string) => {
  const headElem = document.querySelector('head')
  const tag1 = document.createElement('script')
  const tag2 = document.createElement('script')

  tag1.charset = 'utf-8'
  tag1.type = 'text/javascript'
  tag1.appendChild(document.createTextNode(content))

  tag2.src = APP_DYNAMICS_CDN

  Array.from([tag1, tag2]).forEach((elem) => {
    headElem?.appendChild(elem)
  })
}

const injectPendoScript = (content: string) => {
  const headElem = document.querySelector('head')
  const tag = document.createElement('script')
  tag.type = 'text/javascript'
  tag.appendChild(document.createTextNode(content))
  headElem?.appendChild(tag)
}

const injectLogRocket = (logRocketConfig: LogRocketConfig) => {
  if (
    logRocketConfig == null ||
    logRocketConfig.serverUrl == null ||
    logRocketConfig.projectName == null ||
    !logRocketConfig.isEnabled
  ) {
    console.error(`Failed to read LogRocket configuration: `, {
      logRocketConfig
    })
    return
  }

  const headElem = document.querySelector('head')
  const tag = document.createElement('script')
  tag.type = 'text/javascript'
  tag.crossOrigin = 'anonymous'
  tag.src = `${logRocketConfig.serverUrl}/LogRocket.js`
  tag.onload = function () {
    console.log(`LogRocket loaded.`)
    // eslint-disable-next-line
    const w: any = window
    if (!w.LogRocket) {
      console.error(`Could not detect LogRocket on script load.`)
      return
    }

    // Initialize LogRocket immediately for unauthenticated tracking
    // This allows us to capture user behavior before they authenticate
    initializeLogRocketForUnauthenticated(logRocketConfig)
  }
  headElem?.appendChild(tag)
}

/**
 * Initialize LogRocket immediately with a temporary session ID.
 * This enables tracking of unauthenticated users to debug issues
 * like lockouts that occur during the login flow.
 */
const initializeLogRocketForUnauthenticated = (
  logRocketConfig: LogRocketConfig
) => {
  // eslint-disable-next-line
  const w: any = window
  if (!w.LogRocket || w.LogRocket._isInitialized) {
    return
  }

  console.log('Initializing LogRocket for unauthenticated session tracking')

  w.LogRocket.init(logRocketConfig.projectName, {
    serverURL: logRocketConfig.serverUrl,
    dom: {
      inputSanitizer: logRocketConfig.inputSanitizer,
      textSanitizer: logRocketConfig.inputSanitizer
    }
  })

  // Generate or retrieve the temporary session ID
  const tempSessionId = getOrCreateUnauthenticatedSessionId()

  // Identify with temporary ID - this will be upgraded when user authenticates
  w.LogRocket.identify(tempSessionId, {
    session_type: 'unauthenticated',
    session_started: new Date().toISOString()
  })

  console.log(
    'LogRocket initialized with unauthenticated session ID:',
    tempSessionId
  )
}

const render = () => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const App = require('./app/App').default

  injectHead(appDynamicsContent())
  injectPendoScript(pendoContent())
  injectLogRocket(getLogRocketConfig())

  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,

    document.getElementById('root')
  )
}

render()

document.documentElement.style.setProperty('--vh', `${vh}px`)

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./app/App', render)
}
